import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import logo from "./img/ivermedi.png";

import LANG_GE from "./font/GE.svg";
import LANG_EN from "./font/EN.svg";

import { Row, Col, Layout, message, Switch } from "antd";

import "antd/es/layout/style/css";

import "antd/es/row/style/css";
import "antd/es/col/style/css";
import "antd/es/message/style/css";
import "antd/es/switch/style/css";

import Loader from "./components/loader";

import device from "./functions/device";

import ContentIn from "./components/Content";
import Pages from "./components/Pages";
import PagesMobile from "./components/PagesMobile";
import { indexAct } from "./components/api/indexAct";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      device: device(),
      info: {},
      lang: "",
    };
  }

  componentDidMount() {
    console.log(this.state);
    this.getAppInfo();
  }

  setInitScroll = () => {
    setTimeout(() => {
      const hash = this.props.location.hash.substring(1);
      if (hash) {
        const offset = document.getElementById(hash);
        const elementPosition = offset.offsetTop - 105;
        window.scroll({
          top: elementPosition,
        });
      }
    }, 300);
  };

  getAppInfo = () => {
    indexAct("GET_APP_INFO", {}, "/").then((data) => {
      if (data.code === 200) {
        this.setState(
          (prevState) => ({
            loading: false,
            info: { ...data.res.info },
            lang: data.res.lang,
          }),
          () => this.setInitScroll()
        );
      } else {
        message.error("შეცდომა!", 5);
      }
    });
  };

  changeLang = (lang) => {
    indexAct("CHANGE_LANG", { lang: lang }, "/").then((data) => {
      if (data.code === 201) {
        this.setState(
          (prevState) => ({
            lang: data.res.lang,
          }),
          () => this.getAppInfo()
        );
      } else {
        message.error("შეცდომა!", 5);
      }
    });
  };

  render() {
    if (this.state.loading) {
      return <Loader />;
    }

    return (
      <Layout>
        <Layout.Header
          className="top-header" /*  top-header-new top-header-new1 */
          style={{ position: "fixed", zIndex: 999, width: "100%" }}
        >
          <Row justify="center">
            <Col md={5} xs={12} sm={12}>
              <a href={`${window.APP.baseName}`} className="logo">
                <img alt="logo" src={logo} />
              </a>
            </Col>
            <Col md={15} xs={0} sm={0}>
              <Pages {...this.state} {...this.props} />
            </Col>
            <Col
              md={{ span: 4, push: 2 }}
              xs={{ span: 12, push: 7 }}
              sm={{ span: 12, push: 7 }}
            >
              <Switch
                className="lang"
                checkedChildren={
                  <img
                    alt="lang_ge"
                    src={LANG_GE}
                    style={{ display: "block", width: "18px" }}
                  />
                }
                unCheckedChildren={
                  <img
                    alt="lang_en"
                    src={LANG_EN}
                    style={{ display: "block", width: "18px" }}
                  />
                }
                checked={this.state.lang === "GE" ? false : true}
                onChange={(checked) => {
                  const lang = checked ? "EN" : "GE";
                  this.changeLang(lang);
                }}
              />
            </Col>
          </Row>
        </Layout.Header>
        <Layout.Content style={{ marginTop: 90 }}>
          <ContentIn {...this.state} {...this.props} />
          {this.state.device.isMobile ? (
            <div
              style={{
                position: "fixed",
                bottom: "-1px",
                left: 0,
                width: "100%",
                height: "50px",
                background: "#fff",
                zIndex: 999,
                boxShadow: "0 -1px 4px rgba(0,21,41,.08)",
              }}
            >
              <PagesMobile {...this.state} {...this.props} />
            </div>
          ) : (
            ""
          )}
        </Layout.Content>
      </Layout>
    );
  }
}

export default withRouter(App);
